import clsx from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { hideAuthModals } from '../actions/ui';
import { RootState } from '../config/store';
import StripeContainer from '../pages/Cart/strip/StripeContainer';
import Text from './Text';

export interface PaymentModalProps {
    done: Function
}

const PaymentModal: React.FC<PaymentModalProps> = ({ done }) => {

    const dispatch = useDispatch();


    const show = useSelector<RootState, boolean>(
        (state) => state.ui.showPaymentModal,
    );

    const data = useSelector<RootState, any>(
        (state) => state.ui.userData,
    );
    const classes = useStyles();




    const onHide = useCallback(() => {
            dispatch(hideAuthModals());
    }, [dispatch]);

    return (
        <Modal
            dialogClassName={clsx(classes.modal, 'auth-modal')}
            centered
            show={show}
            onHide={onHide}

        >
            <Modal.Header className={classes.header} closeButton={true}>
                <Modal.Title>
                    <Text className="m-0" color="white">
                        Payment
                    </Text>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4">
                <StripeContainer done={done} clientSecret={data.clientSecret} />
            </Modal.Body>
        </Modal>
    );
}

const useStyles = createUseStyles({
    modal: {
        width: '100%',
        maxWidth: '500px',
    },
    header: {
        borderRadius: '5px !important',
        backgroundColor: '#522583',
        borderBottomLeftRadius: '0 !important',
        borderBottomRightRadius: '0 !important',
    }
});


export default PaymentModal;
